export default __webpack_public_path__ + "static/media/Choose your army and build your strategic skills.70e7302c.webm";